import React, { Component } from 'react';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import Notfication from './../../utils/notification-helper';
import SendEmail from '../../components/send-email-component';
import WorkflowStepBaseComponent from './workflow-step-base';
import moment from 'moment';
import PrimeResource from '../../resources/prime-resouce';
import Cons from '../../../isomorphic/cons';
import TimelineRenderHelper from './timeline/timeline-render-helper';
import Notification from '../../utils/notification-helper';
import EmailHelper from '../../utils/email-helper';
import StepActionButtons from './components/step-actions';
import StepHistory from '../../components/step-history';
import StepSendEmail from './components/step-send-email';

@inject('appStore')
@observer
export default class ClientIntroductionCoopAgentEmailListingGonePending extends WorkflowStepBaseComponent {
    constructor(props) {
        super(props);
        this.state = { coopAgents: [], portalEmail: {} };
        this.primeResource = new PrimeResource();
        this.renderIncompleteView.bind(this);
    }

    componentDidMount() {
        this.props.appStore.tcFileStore
            .getContactsForSelectedFile(Cons.prime.fileContactType.CoBroker)
            .then(contacts => {
                this.setState({ coopAgents: contacts });
            })
            .catch(err => {
                console.log(err);
                Notification.ToastError('Failed to contacts for transaction');
            });
        this.props.appStore.tcFileStore
            .getSkySlopeFileForSelectedFile()
            .then(file => {
                this.setState({ portalEmail: { email: file.PortalEmail, name: 'Property' } });
            })
            .catch(err => {
                console.log(err);
                Notification.ToastError('Failed to portal email for transaction');
            });
    }

    onSent(emailModel) {
        const step = this.props.step;

        step.state.isComplete = true;
        step.state.data.model = emailModel;
        step.state.data.sentDate = moment().format();

        return this.updateStepState(step);
    }

    renderCompleteView(step) {
        return (
            <div>
                <StepSendEmail
                    model={step.state.data.model}
                    step={this.props.step}
                    sentDate={step.state.data.sentDate}
                />
                <div className={'col-md-12'}>
                    <StepHistory
                        transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                        emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                    />
                </div>
            </div>
        );
    }

    renderIncompleteView() {
        if (this.state.coopAgents.length <= 0) {
            return (
                <div>
                    <StepActionButtons viewStore={this.viewStore} step={this.props.step} />
                    <span>No co-op agent found for this transaction</span>
                    <div className={'col-md-12'}>
                        <StepHistory
                            transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                            emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                        />
                    </div>
                </div>
            );
        } else {
            const agent = _.clone(this.props.appStore.tcFileStore.selectedFile.agent),
                portalEmail = this.state.portalEmail,
                timelineWorkflowStep = this.props.appStore.workflowStore.workflowState.get(
                    '572ace14-fb4a-4fdb-8acc-c9f4c3260c45'
                ),
                contractAcceptanceDate =
                    !_.isEmpty(timelineWorkflowStep) && !_.isEmpty(timelineWorkflowStep.data.contractAcceptanceDate)
                        ? TimelineRenderHelper.formatTimelineInstanceDate(
                              timelineWorkflowStep.data.contractAcceptanceDate
                          )
                        : null,
                timelines =
                    timelineWorkflowStep && timelineWorkflowStep.isComplete
                        ? _.filter(timelineWorkflowStep.data.timeline.slice(), x => {
                              return !x.excludeFromEmailGrid;
                          })
                        : [],
                timelinesMapped = timelines.map(timeline => {
                    return {
                        name: timeline.name,
                        date: TimelineRenderHelper.formatTimelineInstanceDate(
                            timeline.deadlineCalculated,
                            timeline.exclude
                        ),
                        dateShift: TimelineRenderHelper.formatTimelineInstanceDateShift(
                            timeline.weekendDateShift,
                            timeline.holidayDateShift,
                            timeline.exclude
                        ),
                    };
                }),
                timelineGeneratedOn =
                    timelineWorkflowStep && timelineWorkflowStep.isComplete
                        ? timelineWorkflowStep.data.timelineGeneratedOn
                        : null,
                isNA = this.props.step.state.isMarkedNotApplicable;
            let recipients = EmailHelper.generateRecipientsFromSkySlopeContacts(this.state.coopAgents);

            return (
                <div>
                    <StepActionButtons viewStore={this.viewStore} step={this.props.step} />
                    {isNA ? null : <hr className="section-header" />}
                    {this.state.portalEmail && this.state.coopAgents.length > 0 ? (
                        <StepSendEmail
                            step={this.props.step}
                            timelineGeneratedDate={timelineGeneratedOn}
                            updateStepState={this.updateStepState.bind(this)}
                            typeOfSale={this.props.appStore.tcFileStore.selectedFile.typeOfSale}
                            toEmails={this.state.coopAgents}
                            ccEmails={[agent.emailContact, portalEmail]}
                            template={'introduction-co-op-agent-sale'}
                            extraTemplateData={{
                                agent,
                                recipients: recipients,
                                timelines: timelinesMapped,
                                contractAcceptanceDate: contractAcceptanceDate,
                            }}
                            isHidden={isNA}
                            onSent={this.onSent.bind(this)}
                            hasCancelHandler={this.props.hasCancelHandler}
                        />
                    ) : null}
                    <div className={'col-md-12'}>
                        <StepHistory
                            transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                            emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                        />
                    </div>
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/introduction-co-op-agent-sale-email.js